import React, { useState, useEffect } from 'react';
import { findQueryValueFromString, getPageNumberFromURL } from '../../utils';
import { Helmet } from 'react-helmet';
import * as ArticlesAPI from '../../../api/ArticlesAPI';
import { SafeImagePreview } from '../shared/SafeImagePreview';

function ArticlesPage({ current_user, will_paginate }) {
	const [articles, setArticles] = useState([]);

	useEffect(() => {
		const fetchArticles = async () => {
			const page = getPageNumberFromURL(window.location.href);
			const { data } = await ArticlesAPI.getArticles(page);
			setArticles(data);
		};
		fetchArticles();
	}, []);

	// Components
	const SearchArea = () => {
		const searchValueInURL = findQueryValueFromString(window.location.href);
		const [searchValue, setSearchValue] = useState(searchValueInURL || '');

		const handleOnChange = (e) => {
			// TODO: Do a debounce so we dont have to reply of pressing enter each time
			setSearchValue(e.target.value);
		};

		return (
			<form>
				<input name="utf8" type="hidden" value="✓"></input>
				<div className="columns">
					<label htmlFor="q">Search Sponsor Circle news for:</label>
				</div>
				<div className="columns medium-10 small-8">
					<input
						type="text"
						name="q"
						id="q"
						value={searchValue}
						onChange={handleOnChange}
					/>
				</div>
				<div className="columns medium-2 small-4 text-right">
					<button
						name="button"
						type="submit"
						className="primary-button"
						style={{ marginTop: '-0.4rem' }}
					>
						<p>Search</p>
					</button>
				</div>
			</form>
		);
	};

	const AddNewButton = () => {
		if (!current_user) return null;

		return (
			<a className="primary-button" href="/articles/new">
				<p>Add News</p>
			</a>
		);
	};

	const PaginationControls = () => {
		if (!will_paginate) return null;

		return (
			<div
				className="pagination-controls"
				dangerouslySetInnerHTML={{ __html: will_paginate }}
			></div>
		);
	};

	const ArticlesList = () => {
		if (articles.length === 0) {
			return <p>Sorry - we didn't find any matches for that.</p>;
		}

		return (
			<div className="masonry">
				{articles.map((article) => {
					return (
						<div
							key={article.id}
							className="masonry-item"
							id="article"
						>
							<div className="text-right">
								{article.posted_on}
							</div>
							<div className="card-title">{article.title}</div>
							<SafeImagePreview
								className="card-image"
								article={article}
								disableRedirect={true}
							/>
							<div
								className="card-blurb"
								dangerouslySetInnerHTML={{
									__html: article.body,
								}}
							></div>
							<strong>
								<a href={`/articles/${article.id}`}>
									See the full article
								</a>
							</strong>
						</div>
					);
				})}
			</div>
		);
	};

	// Render
	return (
		<>
			<Helmet>
				<title>
					Industry announcements about corporate partnerships.
				</title>
				<meta
					name="description"
					content="Sponsor Circle allows corporate sponsors and properties to profile their partnerships."
				/>
			</Helmet>
			<div className="row" id="articles">
				<div className="columns small-10 small-offset-1 medium-8 medium-offset-2">
					<div className="row">
						<SearchArea />
					</div>
					<AddNewButton />
					<ArticlesList />
					<PaginationControls />
				</div>
			</div>
		</>
	);
}

export default ArticlesPage;
